export default {
  id: 191,
  title: 'Target #191 - Modern Fence',
  url: 'https://cssbattle.dev/play/191',
  colors: ['#2F2E59', '#EEECF6'],
  solution:
    '<p a><p b><p c><style>p[b],p[c]{width:240;height:20;rotate:30deg}body{background:#2f2e59;margin:0}p{position:fixed;background:#eeecf6;border-radius:1in}p[a]{top:59;left:77;width:20;height:150;box-shadow:226px 0 #eeecf6}p[b]{top:64.5;left:91;box-shadow:0 57px #eeecf6}p[c]{bottom:64.5;right:91;box-shadow:0 -57px #eeecf6',
}
